import { render, staticRenderFns } from "./SectionApvaIntro.vue?vue&type=template&id=3058c22e&"
import script from "./SectionApvaIntro.vue?vue&type=script&lang=js&"
export * from "./SectionApvaIntro.vue?vue&type=script&lang=js&"
import style0 from "./SectionApvaIntro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports